import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className:
    'flex flex-col items-start p-2xl u:gap-md u:bg-background-strong-hover sm:rounded-t-xl lg:px-4xl'
});

export const HeadingContent = createComponent('h4', {
  className: 't-heading-sm u:text-text-inverse lg:t-heading-md'
});

export const Description = createComponent('h4', {
  className: 't-body-sm u:text-text-inverse'
});
